import { carouselData } from '@/mocks/home';

export default function Carousel() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">焦点专题</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">深度聚焦娱乐圈最值得关注的话题与事件，全方位多角度解读</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {carouselData.map((item) => (
            <article
              key={item.id}
              className="group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[2/1] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <span className="absolute top-4 left-4 px-3 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-semibold">
                  {item.category}
                </span>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-heading font-bold text-foreground-950 mb-3 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">{item.summary}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}